import { render, staticRenderFns } from "./RyomaTextArea.vue?vue&type=template&id=fb92135e&scoped=true&"
import script from "./RyomaTextArea.vue?vue&type=script&lang=js&"
export * from "./RyomaTextArea.vue?vue&type=script&lang=js&"
import style0 from "./RyomaTextArea.vue?vue&type=style&index=0&id=fb92135e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb92135e",
  null
  
)

export default component.exports